var map = {
	"./": [
		"./src/effects/index.ts",
		9
	],
	"./ICanvasEffect": [
		"./src/effects/ICanvasEffect.ts",
		7,
		5215
	],
	"./ICanvasEffect.ts": [
		"./src/effects/ICanvasEffect.ts",
		7,
		5215
	],
	"./confetti": [
		"./src/effects/confetti/index.ts",
		9,
		1
	],
	"./confetti/": [
		"./src/effects/confetti/index.ts",
		9,
		1
	],
	"./confetti/index": [
		"./src/effects/confetti/index.ts",
		9,
		1
	],
	"./confetti/index.ts": [
		"./src/effects/confetti/index.ts",
		9,
		1
	],
	"./effect": [
		"./src/effects/effect.ts",
		9,
		3508
	],
	"./effect.ts": [
		"./src/effects/effect.ts",
		9,
		3508
	],
	"./fireworks": [
		"./src/effects/fireworks/index.ts",
		9,
		3636
	],
	"./fireworks/": [
		"./src/effects/fireworks/index.ts",
		9,
		3636
	],
	"./fireworks/index": [
		"./src/effects/fireworks/index.ts",
		9,
		3636
	],
	"./fireworks/index.ts": [
		"./src/effects/fireworks/index.ts",
		9,
		3636
	],
	"./hearts": [
		"./src/effects/hearts/index.ts",
		9,
		1095
	],
	"./hearts/": [
		"./src/effects/hearts/index.ts",
		9,
		1095
	],
	"./hearts/index": [
		"./src/effects/hearts/index.ts",
		9,
		1095
	],
	"./hearts/index.ts": [
		"./src/effects/hearts/index.ts",
		9,
		1095
	],
	"./index": [
		"./src/effects/index.ts",
		9
	],
	"./index.ts": [
		"./src/effects/index.ts",
		9
	],
	"./rainfall": [
		"./src/effects/rainfall/index.ts",
		9,
		3197
	],
	"./rainfall/": [
		"./src/effects/rainfall/index.ts",
		9,
		3197
	],
	"./rainfall/index": [
		"./src/effects/rainfall/index.ts",
		9,
		3197
	],
	"./rainfall/index.ts": [
		"./src/effects/rainfall/index.ts",
		9,
		3197
	],
	"./snowfall": [
		"./src/effects/snowfall/index.ts",
		9,
		2792
	],
	"./snowfall/": [
		"./src/effects/snowfall/index.ts",
		9,
		2792
	],
	"./snowfall/index": [
		"./src/effects/snowfall/index.ts",
		9,
		2792
	],
	"./snowfall/index.ts": [
		"./src/effects/snowfall/index.ts",
		9,
		2792
	],
	"./spaceinvaders": [
		"./src/effects/spaceinvaders/index.ts",
		9,
		4522
	],
	"./spaceinvaders/": [
		"./src/effects/spaceinvaders/index.ts",
		9,
		4522
	],
	"./spaceinvaders/index": [
		"./src/effects/spaceinvaders/index.ts",
		9,
		4522
	],
	"./spaceinvaders/index.ts": [
		"./src/effects/spaceinvaders/index.ts",
		9,
		4522
	],
	"./utils": [
		"./src/effects/utils.ts",
		9
	],
	"./utils.ts": [
		"./src/effects/utils.ts",
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/effects lazy recursive ^\\.\\/.*$ referencedExports: default";
module.exports = webpackAsyncContext;